// First-touch attribution + onboarding answers, staged in localStorage until
// signup carries them to the backend (SignupPage sends them in the signup
// payloads; the server writes them onto UserProfile before the Stripe
// redirect, so nothing here needs to survive the checkout round-trip).
//
// localStorage, not sessionStorage, on purpose: social visitors bounce and
// come back days later — first touch should win. All storage access is
// wrapped: attribution must never throw (Safari private mode, blocked
// storage, quota).

const KEY = "muraja.onboarding.v1";

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
}

function write(data) {
  try {
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    // Best-effort only.
  }
}

// Called once at module scope in index.js (like initAnalytics), on every entry
// route — a visitor landing on /, /irab, or /start with utm_* params is
// captured wherever they arrive. First touch only: never overwrites.
export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const source = (params.get("utm_source") || "").trim();
    const campaign = (params.get("utm_campaign") || "").trim();
    if (!source && !campaign) return;
    const data = read();
    if (data.utm_source || data.utm_campaign) return;
    write({
      ...data,
      utm_source: source,
      utm_campaign: campaign,
      captured_at: new Date().toISOString(),
    });
  } catch {
    // Never let attribution break page load.
  }
}

export function saveOnboardingAnswers(partial) {
  write({ ...read(), ...partial });
}

export function getOnboarding() {
  return read();
}

export function clearOnboarding() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Best-effort only.
  }
}

// The signup payload's `onboarding` object, or null when nothing was captured.
// Field names match what the backend's apply_onboarding_payload expects.
export function buildSignupOnboardingPayload() {
  const data = read();
  const payload = {};
  if (data.utm_source) payload.utm_source = data.utm_source;
  if (data.utm_campaign) payload.utm_campaign = data.utm_campaign;
  if (data.motivation) payload.learning_motivation = data.motivation;
  if (data.script_level) payload.arabic_script_level = data.script_level;
  if (data.daily_minutes) payload.daily_goal_minutes = data.daily_minutes;
  return Object.keys(payload).length ? payload : null;
}
